import { Typography } from '@mui/material';

import SunnysideGrid from '../../../components_sunnyside/grid';
import { colors } from '../../../styles/_colors';
import SunnysideTable from '../../../components_sunnyside/table';
import React from 'react';
import SunnysideLink from '../../../components_sunnyside/link';
import { PrismicBasicPageResponseData } from '../../../utils/prismic/types/pages/basic.type';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import { PrismicBodyText } from '../../../utils/prismic/types/prismic-slice.type';
import cookiePolicySerializer from '../../../utils/prismic/serializers/cookiePolicySerializer';

interface CookiePolicyProps {
    cookiePolicy: PrismicBasicPageResponseData
}

export default function CookiePolicy(props: CookiePolicyProps): JSX.Element {
    const { cookiePolicy } = props;
    const headers = [
        'Type', 
        'Description', 
        'Who serves the cookies (link to privacy policy/site)', 
        'How to control them'
    ];
    const rows = [
        ['Advertising', 
            'These cookies are used by advertising companies to collect information about how you use our Sites and other websites over time. These companies use this information to show you ads they believe will be relevant to you within our services and elsewhere, and to measure how the ads perform.',
            <React.Fragment key='advertising_links'>
                <SunnysideLink color={colors.sky} underline href='/'>Facebook</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Google</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Twitter</SunnysideLink>
            </React.Fragment>,
            <Typography key='advertising_cookies'>
                You can opt-out of Facebook cookies <SunnysideLink color={colors.sky} underline href='/'>here</SunnysideLink>.
                <br/><br/>
                You can opt-out of Google cookies <SunnysideLink color={colors.sky} underline href='/'>here</SunnysideLink>.
                <br/><br/>
                See ‘your choices’ below.
            </Typography>,
        ],
        ['Analytics', 
            'These cookies help us understand how our services is performing and being used. These cookies may work with web beacons included in emails we send to track which emails are opened and which links are clicked by recipients.',
            <React.Fragment key='analytics_links'>
                <SunnysideLink color={colors.sky} underline href='/'>Amplitude</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Google Analytics</SunnysideLink>
            </React.Fragment>,
            <React.Fragment key='analytics_cookies'>
                Google Analytics uses its own 
                cookies. You can find out more information about Google 
                Analytics cookies <SunnysideLink color={colors.sky} underline href='/'>here</SunnysideLink> and about how Google 
                protects your data <SunnysideLink color={colors.sky} underline href='/'>here</SunnysideLink>. You can prevent the 
                use of Google Analytics relating to your use of our Sites by downloading 
                and installing a browser plugin available here. 
                <br/><br/>
                You can tell Hotjar not to collect your data here. 
                <br/><br/>
                See ‘your choices’ below.
            </React.Fragment>
        ],
        ['Essential', 
            'These cookies are necessary to allow the technical operation of our services (e.g., they enable you to move around on a website and to use its features).',
            <React.Fragment key='essential_links'>
                <SunnysideLink color={colors.sky} underline href='/'>Adobe Typekit</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Google Tag Manager</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Cloudfare</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Squarespace</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Memberstack</SunnysideLink>
                <br/><br/>
                <SunnysideLink color={colors.sky} underline href='/'>Stripe</SunnysideLink>
            </React.Fragment>,
            'See ‘your choices’ below.'
        ],
        ['Functionality/performance', 
            'Enhance the performance and functionality of our services.',
            'N/A',
            'See ‘your choices’ below.'
        ],
    ];
    const sliceObject = cookiePolicy.data.body[0].primary as PrismicBodyText;
    const richTextBlock = sliceObject.body_text as RichTextBlock[];
    return (
        <SunnysideGrid maxwidthgrid
            display='flex'
            flexDirection='column'>
            <RichText
                render={richTextBlock}
                htmlSerializer={cookiePolicySerializer}
            />
        </SunnysideGrid>
    );
}